import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Grid, Typography } from '@mui/material';
import WrongLocationRoundedIcon from '@mui/icons-material/WrongLocationRounded';
import Footer from '../Components/Footer';

function Notfound() {
    return (
      <>
      <Box
      sx={{
      bgcolor: 'background.paper',
      pt: 2,
      pb: 6,
      mt: 2,
      }}
  >
    <Container maxWidth="lg">
        <Grid item>
          <Typography variant="h2" color="text.disabled">
            <WrongLocationRoundedIcon sx={{ fontSize: '4rem', verticalAlign:'middle' }} color="secondary"/> 
            This page does not exist
          </Typography>
        </Grid>
      
        <Grid item mt={3} >
          <Button variant="contained"component={RouterLink} to="/">Back to home page</Button>
        </Grid>
      </Container>
      </Box>
      <Footer />
      </>
    )
}

export default Notfound